import {
  ConditionalFormConfig,
  ConditionalFormTicketProps,
} from 'features/libra/stepComponents/conditionalForm/api/conditionalFormApi'
import { evaluateCondition } from 'features/libra/stepComponents/conditionalForm/conditions/evaluateConditionalFormCondition'

export const getVisibleSectionIds = (
  form: ConditionalFormConfig['form'],
  fieldValues: ConditionalFormTicketProps['fieldValues']
): ReadonlyArray<string> => {
  return form
    .filter(({ showWhen }) =>
      showWhen.every((condition) => evaluateCondition(condition, fieldValues))
    )
    .map(({ sectionId }) => sectionId)
}
